import React, { useMemo, useCallback, useState, useEffect } from "react";
import { useRef } from "react";

const LensCreatedData = ({
  combinedV,
  addValue,
  fetchLensPowerData,
  GetdataForUpdate,
  GetdataForUpdateCopy,
  axisValue,
  SelectedAxis,
}) => {
  const [localData, setLocalData] = useState(fetchLensPowerData);

  const inputRefs = useRef([]);
  const totalCols = addValue.length * 6;

  useEffect(() => {
    inputRefs.current = [];
  }, [combinedV.length, addValue.length]);

  const handleKeyDown = (e, flatIndex) => {
    const colCount = totalCols;
    let nextIndex = flatIndex;

    switch (e.key) {
      case "ArrowRight":
        nextIndex = flatIndex + 1;
        break;
      case "ArrowLeft":
        nextIndex = flatIndex - 1;
        break;
      case "ArrowDown":
        nextIndex = flatIndex + colCount;
        break;
      case "ArrowUp":
        nextIndex = flatIndex - colCount;
        break;
      default:
        return;
    }

    const target = inputRefs.current[nextIndex];
    if (target) {
      target.focus();
      e.preventDefault();
    }

    setTimeout(() => {
      target.select();
    }, 0);
  };

  useEffect(() => {
    ;
    setLocalData(fetchLensPowerData);
  }, [fetchLensPowerData.length, axisValue, SelectedAxis]);

  console.log("localData", localData);
  // console.log('addValue',addValue);
  // 🔹 Create a lookup table for quick data retrieval
  const filteredData = useMemo(() => {
    const map = new Map();
    localData.forEach((item) => {
      const key = `${parseFloat(item.sph || "0.00").toFixed(2)}_${parseFloat(
        item.cyl || "0.00"
      ).toFixed(2)}_${parseFloat(item.axis || "0").toFixed(2)}_${parseFloat(
        item.add || "0.00"
      ).toFixed(2)}`;
      if (!map.has(key)) map.set(key, item);
    });
    return map;
  }, [localData]);

  console.log("filteredData", filteredData);

  // 🔹 Optimize `GetdataForUpdate` with `useCallback`
  const handleInputChange = useCallback(
    (e, d2Id) => {
      const { name, value } = e.target;

      const shouldValidateNumber =
        name !== "boxNumber" && name !== "defaultBarcode";
      const isValidNumber =
        !shouldValidateNumber || /^-?\d*(\.\d*)?$/.test(value);

      if (isValidNumber) {
        // Don't convert to number until you are saving — keep input smooth
        const parsedValue = shouldValidateNumber ? value : value;

        // Update local state (keep number as string for typing ease)
        setLocalData((prev) =>
          prev.map((item) =>
            item.d2Id === d2Id ? { ...item, [name]: parsedValue } : item
          )
        );

        // Delay conversion & update
        setTimeout(() => {
          const finalValue = shouldValidateNumber ? Number(value) : value;
          const eventClone = {
            ...e,
            target: { ...e.target, value: finalValue },
          };
          GetdataForUpdate(eventClone, d2Id);
        }, 300);
      }
    },
    [GetdataForUpdate]
  );

  const handleCopyBtnClick = (key, value, rIndex, addWithSign) => {
    let tempLocalData = [...localData];

    for (let i = 0; i < tempLocalData.length; i++) {
      if (tempLocalData[i].addWithSign == addWithSign) {
        tempLocalData[i][key] =
          key === "boxNumber" || key === "defaultBarcode"
            ? value
            : Number(value);
      }
    }

    setLocalData(tempLocalData);
    GetdataForUpdateCopy(key, value, rIndex, addWithSign);
  };

  const handleCopyBtnClick2 = (key, value, rIndex) => {
    let tempLocalData = [...localData];

    for (let i = 0; i < tempLocalData.length; i++) {
      tempLocalData[i][key] =
        key === "boxNumber" || key === "defaultBarcode" ? value : Number(value);
    }

    setLocalData(tempLocalData);
    GetdataForUpdateCopy(key, value, rIndex, undefined);
  };

  const [copyBtnRC, setCopyBtnRC] = useState({ R: -1, C: -1, SC: -1 });

  function handleRightClick(e, rIndex, cIndex, scIndex) {
    e.preventDefault();
    console.log(copyBtnRC);
    console.log({ rIndex, cIndex, scIndex });

    if (
      copyBtnRC.R == rIndex &&
      copyBtnRC.C == cIndex &&
      copyBtnRC.SC == scIndex
    ) {
      setCopyBtnRC({ R: -1, C: -1, SC: -1 });
    } else {
      setCopyBtnRC({ R: rIndex, C: cIndex, SC: scIndex });
    }
  }

  useEffect(() => {
    const handleClickOutside = () => {
      setCopyBtnRC({ R: -1, C: -1, SC: -1 });
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    // console.log({ combinedV, addValue });
  }, [combinedV, addValue]);

  return (
    <tbody>
      {combinedV.map((data, index1) => {
        // Find the first valid item in this row
        let firstValidItem = null;
        for (let i = 0; i < addValue.length; i++) {
          const key = `${parseFloat(data.sph || "0.00").toFixed(
            2
          )}_${parseFloat(data.cyl || "0.00").toFixed(2)}_${parseFloat(
            data.axis || "0"
          ).toFixed(2)}_${parseFloat(addValue[i] || "0.00").toFixed(2)}`;
          if (filteredData.has(key)) {
            firstValidItem = filteredData.get(key);
            break;
          }
        }

        return (
          <tr className="TrLensCreation" key={index1}>
            {/* ✅ Always render first valid item SPH, CYL, AXIS in first 3 cells */}
            <td className="firstColumnCellStyle tableData rows_indicator ButtonStick1">
              {firstValidItem ? firstValidItem.sph?.toFixed(2) : "--"}
            </td>
            <td className="firstColumnCellStyle tableData rows_indicator ButtonStick2">
              {firstValidItem ? firstValidItem.cyl?.toFixed(2) : "--"}
            </td>
            <td className="firstColumnCellStyle tableData rows_indicator ButtonStick">
              {firstValidItem
                ? isNaN(Number(firstValidItem.axis)) ||
                  Number(firstValidItem.axis) === 0
                  ? "--"
                  : firstValidItem.axis
                : "--"}
            </td>

            {/* Loop through each column of the row */}
            {addValue.map((value4, index4) => {
              const key = `${parseFloat(data.sph || "0.00").toFixed(
                2
              )}_${parseFloat(data.cyl || "0.00").toFixed(2)}_${parseFloat(
                data.axis || "0"
              ).toFixed(2)}_${parseFloat(value4 || "0.00").toFixed(2)}`;
              const item = filteredData.get(key);
              const startIndex = index1 * totalCols + index4 * 6;

              if (!item) {
                return [...Array(6)].map((_, i) => (
                  <td key={`empty-${index4}-${i}`}>
                    <input
                      type="text"
                      disabled
                      className="tableBox"
                      value="-"
                      style={{ textAlign: "center" , background:"#f7f7f7" }}
                    />
                  </td>
                ));
              }

              const fields = [
                { name: "defaultBarcode", value: item.defaultBarcode },
                { name: "boxNumber", value: item.boxNumber || "" },
                { name: "alertQty", value: item.alertQty },
                { name: "purchasePrice", value: item.purchasePrice },
                { name: "salePrice", value: item.salePrice },
                { name: "openingStock", value: item.openingStock },
              ];

              return fields.map((field, subIndex) => {
                const fieldIndex = startIndex + subIndex;
                const showCopyButtons =
                  copyBtnRC.R === index1 &&
                  copyBtnRC.C === index4 &&
                  copyBtnRC.SC === subIndex;

                return (
                  <td
                    key={subIndex}
                    onContextMenu={(e) =>
                      handleRightClick(e, index1, index4, subIndex)
                    }
                    style={{ position: "relative" }}
                    className="tableData rows_indicator"
                  >
                    {field.name === "defaultBarcode" && (
                      <input
                        type="hidden"
                        className="tableBox"
                        value={item.id}
                        required
                      />
                    )}
                    <input
                      className="tableBox"
                      type="text"
                      name={field.name}
                      value={field.value}
                      onChange={(e) => handleInputChange(e, item.d2Id)}
                      required
                      ref={(el) => (inputRefs.current[fieldIndex] = el)}
                      onKeyDown={(e) => handleKeyDown(e, fieldIndex)}
                    />

                    {showCopyButtons && (
                      <>
                        <button
                          onClick={() =>
                            handleCopyBtnClick(
                              field.name,
                              field.value,
                              index1,
                              item.addWithSign
                            )
                          }
                          className="product-price-account-wise-copy-button"
                          style={{
                            height: "20px",
                            width: "95px",
                            right: "-90px",
                            top: "0px",
                          }}
                        >
                          <i className="fa-solid fa-copy"></i> Copy
                        </button>
                        <button
                          onClick={() =>
                            handleCopyBtnClick2(field.name, field.value, index1)
                          }
                          className="product-price-account-wise-copy-button"
                          style={{
                            height: "20px",
                            width: "95px",
                            right: "-90px",
                            top: "21px",
                          }}
                        >
                          <i className="fa-solid fa-copy"></i> Copy To All
                        </button>
                      </>
                    )}
                  </td>
                );
              });
            })}
          </tr>
        );
      })}
    </tbody>
  );
};

export default LensCreatedData;
